import { Router, ActivatedRoute} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BreadCrumbService, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { TransactionService } from '../shared/';
import { DatePipe } from '@angular/common';
import { ReportService } from './../../shared/';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';


@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  providers: [TransactionService],
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  public selectedCtn: string;
  public startDate: string;
  public endDate: string;
  public format: string;
  public dateRange: any;
  public fan: string;
  public singleDevice: boolean;
  constructor(private stepIndicator: StepIndicatorService,
    private transactionService: TransactionService,
    private datePipe: DatePipe,
    private breadCrumbService: BreadCrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService) { }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.stepIndicator.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicator.setVisibility(true);
    const reportRequest = this.transactionService.getReportModel();
    this.loadData(reportRequest);
    this.transactionService.createPageLoadProperties('CONFIRMATION', 'confirmation');
  }
  loadData(reportRequest) {
    this.singleDevice = reportRequest.accountType === 'singleDevice';
    this.fan = reportRequest.selectedFan ? reportRequest.selectedFan.name : '';
    this.selectedCtn = reportRequest.selectedCtn.ctn ? reportRequest.selectedCtn.ctn.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3') : '';
    this.startDate = this.datePipe.transform(reportRequest.startDate, 'MM/dd/yyyy');
    this.endDate = this.datePipe.transform(reportRequest.endDate, 'MM/dd/yyyy');
    this.format = reportRequest.format;
    this.dateRange = reportRequest.dateRange.name;
  }
  backToCallingPage() {
    const breadCrumb = this.breadCrumbService.getBreadCrumbs();
    const route = breadCrumb[breadCrumb.length - 2].routerLink;
    this.router.navigate([route]);

  }
}
